import APIKit from "../Allapis/Apikit/apikit";

export const getPointsServer = async (id) => {
  const endpoint = id ? `/rewards/${id}` : `/rewards`;
  const res = await APIKit.get(endpoint);
  console.log("Getresponse6", res.data);
  return res.data;
};

export const updatePointsServer = async (id, values) => {
  const res = await APIKit.put(`/points/${id}`, values);
  console.log({ resupdate: res });
  return res.data;
};

export const createAndUpdatePointsServer = async (id, values) => {
  let res;
  if (id) {
    res = await APIKit.post(`/rewards/${id}`, values);
  } else {
    res = await APIKit.post(`/rewards`, values);
  }
  return res.data;
};

export const deletePointsServer = async (del_id) => {
  console.log("del_id");
  const res = await APIKit.put(`/rewards/${del_id}`);
  console.log({ resdelete: res });
  return res.data;
};
